import React from 'react';

import styled from 'styled-components';

import { defineMessages, useIntl } from '@techstyle/react-intl';

import { withShoppingBagRevampUX } from '../MemberCreditsCartToggle/WithShoppingBagRevampUX';

import { CreditStatus } from './utils';

const getDerivedStylingFromCreditStatus = ({
  creditStatus,
  isShoppingBagRevampUX,
  theme,
}) => {
  switch (creditStatus) {
    case CreditStatus.applied:
    case CreditStatus.applying:
      return `background: ${
        isShoppingBagRevampUX ? theme.colors.lavender : theme.colors.promo
      }`;
    case CreditStatus.unavailable:
    case CreditStatus.no_credits_remaining:
      return `
        cursor: default;
        background: ${
          isShoppingBagRevampUX ? theme.colors.stone : theme.colors.gray400
        };
        `;
    default:
      return `
        background: ${
          isShoppingBagRevampUX ? theme.colors.stone : theme.colors.subdued
        }
      `;
  }
};

const ToggleButtonStyled = styled.button`
  width: 40px;
  height: 24px;
  border-radius: 12px;
  cursor: pointer;
  ${props => getDerivedStylingFromCreditStatus(props)};
  ${({ isShoppingBagRevampUX }) =>
    isShoppingBagRevampUX &&
    `
    flex-shrink: 0;
  `};
`;
const ToggleButton = withShoppingBagRevampUX(ToggleButtonStyled);

const toggleButtonLabels = defineMessages({
  apply: {
    id: 'global_checkout.apply_member_credits_toggle_button',
    defaultMessage: 'Apply member credits to product',
  },
  remove: {
    id: 'global_checkout.remove_member_credits_toggle_button',
    defaultMessage: 'Remove member credits from product',
  },
});
const Toggle = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 100%;
  margin: 1px;
  transition: 0.1s transform ease-in-out;
  transform: ${props =>
    props.isCreditApplied ? 'translateX(75%)' : 'translateX(0%)'};
  box-shadow: -1px 1px 4px ${props => props.theme.colors.darkShadow1};
  background: ${props => props.theme.colors.white};
`;

export const CreditToggleButton = ({
  isCreditApplied,
  creditStatus,
  handleToggle,
}) => {
  const { formatMessage } = useIntl();

  return (
    <ToggleButton
      aria-label={formatMessage(
        isCreditApplied ? toggleButtonLabels.remove : toggleButtonLabels.apply
      )}
      data-autotag={isCreditApplied ? 'credit_toggle_off' : 'credit_toggle_on'}
      creditStatus={creditStatus}
      onClick={handleToggle}
    >
      <Toggle isCreditApplied={isCreditApplied} />
    </ToggleButton>
  );
};
